<template>
  <div class="exam-question-edit" style="margin: 0.5rem;background-color: #ffffff;border-radius: 0.3rem;">
    <van-form v-if="form" ref="form" label-width="100px" @submit="save()">
      <div style="margin: 0.1rem;">
        <select-pick v-model="form.subjectGroupId" :columns="subjectGroupList" label="选择教材" labelCol="subjectGroupName" valueCol="subjectGroupId"
                     @change="onSubjectGroupChange(JSON.parse(JSON.stringify(form)))" style="margin-bottom: 0.5rem;"></select-pick>
      </div>
      <div style="margin: 0.5rem;">
        <div v-for="(subject,b) in form.subjectList" :key="'b'+b" style="border: 1px solid #F1F5F9;padding-bottom: 0.5rem">
          <div style="color: #666666;margin-bottom: 0.2rem;background-color: #F1F5F9;padding: 0.32rem;border-radius: 0.1rem 0.1rem 0rem 0rem;">
            {{subject.gradeSubjectName}}({{$enums.subjectType[subject.subjectType]}})
          </div>
          <div v-if="subject.subjectDesc"
               style="margin: 0.2rem 0.5rem;background: rgba(255, 97, 90, 0.06);border: 1px solid #FF615A;color: #FF615A;font-size: 0.27rem;padding: 0.1rem 0.2rem 0.1rem;">
            * {{subject.subjectDesc}}
          </div>
          <div v-if="!subject.isGroup && !subject.isQuestionRequired && subject.subjectType==2">
            <div style="padding: 0 0.5rem;margin-top: 0.2rem;">
              <van-checkbox :value="1" disabled class="block" shape="square">
                系统抽题
              </van-checkbox>
            </div>
          </div>
          <template v-else>
            <div v-for="(questionGroup,c) in subject.questionGroupList" :key="'c'+c" style="margin-bottom: 20px;padding: 0 0.5rem;">
              <div v-if="questionGroup.questionGroupName" style="color: #666666;">
                {{questionGroup.questionGroupName}}
                <span v-if="questionGroup.questionGroupDesc">({{questionGroup.questionGroupDesc}})</span>
              </div>
              <div>
                <van-checkbox-group v-model="questionGroup.questionIds" @change="onCheckboxChange(questionGroup)">
                  <van-checkbox v-for="(question,d) in questionGroup.questionList" :key="'d'+d" :name="question.questionId" style="margin-top: 0.2rem;"
                                :disabled="!!question.isRequired || !!question.disabled" class="block" shape="square">
                    <span v-if="question.isRequired" style="color: red;vertical-align: bottom;">*</span> {{question.questionContent}}
                  </van-checkbox>
                </van-checkbox-group>
              </div>
            </div>
          </template>
        </div>
      </div>
    </van-form>
    <div style="height: 1.5rem;"></div>
    <van-button :disabled="disabled" @click="save" :class="disabled?'disabled':''" type="info"
                style="width: calc(100% - 1rem);z-index: 1;bottom: 0.5rem;position: fixed;border: none;opacity: 1;">
      点击提交
    </van-button>
  </div>
</template>
<script>
import { Form, Picker, Popup, Button, Icon, Field, Checkbox, CheckboxGroup, Toast, Dialog } from 'vant'
import SelectPick from '../components/select-pick'

export default {
  components: {
    [Form.name]: Form,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Button.name]: Button,
    [SelectPick.name]: SelectPick
  },
  data () {
    return {
      form: null,
      disabled: true,
      subjectGroupList: []
    }
  },
  async created () {
    await this.initForm()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {
    form: {
      handler: function () {
        try {
          this.checkSubjectGroup()
          this.disabled = false
        } catch (e) {
          this.disabled = true
        }
      },
      deep: true
    }
  },
  methods: {
    async initForm () {
      try {
        let info = this.Tool.getStorage('user-edit-info')
        // 考生科目列表
        let subjectList = []
        // 科目分组列表
        this.subjectGroupList = await this.$HTTP.ApiEnroll.getSubjectGroupList(info.gradeId) || []
        if (this.Tool.isNull(subjectList)) {
          info.subjectGroupId = info.subjectGroupId || this.subjectGroupList[0].subjectGroupId
          // 新增
          info.isAdd = true
          this.onSubjectGroupChange(info)
        } else {
          info.subjectGroupId = subjectList[0].subjectGroupId
          this.onSubjectGroupChange(info, subjectList)
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    onSubjectGroupChange (info, subjectList = []) {
      for (let a in this.subjectGroupList) {
        let subjectGroup = this.subjectGroupList[a]
        if (subjectGroup.subjectGroupId === info.subjectGroupId) {
          info.subjectList = JSON.parse(JSON.stringify(subjectGroup.subjectList))
          for (let b in info.subjectList) {
            let subject = info.subjectList[b]
            for (let c in subject.questionGroupList) {
              let questionGroup = subject.questionGroupList[c]
              let questionIds = []
              for (let d in questionGroup.questionList) {
                let question = questionGroup.questionList[d]
                if (question.isRequired) {
                  questionIds.push(question.questionId)
                }
                if (!this.Tool.isNull(subjectList)) {
                  for (let i in subjectList) {
                    let subject2 = subjectList[i]
                    if (subject2.gradeSubjectId === subject.gradeSubjectId) {
                      for (let j in subject2.questionList) {
                        let question2 = subject2.questionList[j]
                        if (question2.questionGroupId === questionGroup.questionGroupId && question.questionId === question2.questionId && !questionIds.includes(question2.questionId)) {
                          questionIds.push(question2.questionId)
                        }
                      }
                    }
                  }
                }
              }
              questionGroup.questionIds = questionIds
              this.onCheckboxChange(questionGroup)
            }
          }
          this.form = info
          this.$forceUpdate()
        }
      }
    },
    onCheckboxChange (questionGroup) {
      if (questionGroup.questionIds.length >= Number(questionGroup.chooseQuestionNum)) {
        for (let d in questionGroup.questionList) {
          let question = questionGroup.questionList[d]
          if (!questionGroup.questionIds.includes(question.questionId)) {
            question.disabled = true
          }
        }
      } else {
        for (let d in questionGroup.questionList) {
          let question = questionGroup.questionList[d]
          question.disabled = false
        }
      }
    },
    checkSubjectGroup () {
      let info = JSON.parse(JSON.stringify(this.form))
      for (let b in info.subjectList) {
        let subject = info.subjectList[b]
        let questionList = []
        for (let c in subject.questionGroupList) {
          let questionGroup = subject.questionGroupList[c]
          if (questionGroup.questionIds.length < Number(questionGroup.chooseQuestionNum)) {
            if (!subject.isGroup && !subject.isQuestionRequired && Number(subject.subjectType) === 2) {
              console.log('系统抽题')
              let questionIds = []
              for (let d in questionGroup.questionList) {
                let question = questionGroup.questionList[d]
                questionIds.push(question.questionId)
              }
              questionGroup.questionIds = questionIds
            } else {
              throw new Error(`科目${subject.gradeSubjectName}${questionGroup.questionGroupName ? ('(' + questionGroup.questionGroupName + ')') : ''}中应选择${questionGroup.chooseQuestionNum}道题`)
            }
          }
          for (let d in questionGroup.questionList) {
            let question = questionGroup.questionList[d]
            if (questionGroup.questionIds.includes(question.questionId)) {
              questionList.push(question)
            }
          }
        }
        subject.questionList = questionList
      }
      return info
    },
    async save () {
      Dialog.confirm({
        title: "提示",
        message: "请确保考级内容选择无误，点击提交后不可修改",
        confirmButtonColor: "#aa0405",
      }).then(async () => {
        try {
          let isOK = await this.Tool.checkForm(this.$refs['form'])
          if (isOK) {
            let info = this.checkSubjectGroup()
            let orderData = await this.$HTTP.ApiEnroll.commitExamEnroll(this.form, info.subjectList)
            Toast('保存成功')
            this.$AppMethod.zgLog(`订单信息：${JSON.stringify(orderData)}`)
            this.$AppMethod.refreshNativeUserinfo()
            this.$AppMethod.launchOrderPayPage(JSON.stringify(orderData))
          }
        } catch (e) {
          this.Tool.doError(e)
        }
      })
    }
  }
}
</script>
<style>
  .exam-question-edit .disabled {
    background-color: #DFE0E6;
  }
</style>
